module.exports = __webpack_public_path__ + "img/Mivne_Group.b458a757.svg";